import { Slider } from 'antd';
import React, { useEffect } from 'react';

import { useDebounceState } from '../../utils/hooks';

interface RadiusFormGroupProps {
    radius: number;
    setRadius(newRadius: number): void;
    maxRadiusKm?: number;
}

const RadiusFormGroup = ({ radius, setRadius, maxRadiusKm = 50 }: RadiusFormGroupProps) => {
    const [radiusDebounced, radiusValue, setRadiusValue] = useDebounceState(Math.min(radius / 1000, maxRadiusKm), 5e3);

    useEffect(() => {
        if (radiusDebounced !== radius / 1000) {
            setRadius(radiusDebounced * 1000);
        }
    }, [radiusDebounced]);

    return (
        <>
            <div style={{ gridColumn: 1 }}>
                <strong>Search in radius:</strong>
            </div>
            <div style={{ gridColumn: '2 / 6' }}>
                <Slider
                    min={0}
                    max={maxRadiusKm}
                    value={radiusValue}
                    tipFormatter={(value) => `${value}km`}
                    onChange={(value) => setRadiusValue(parseInt(value.toString()))}
                />
            </div>
        </>
    );
};

export default RadiusFormGroup;
